import React, { useCallback, useState } from 'react';
import ChatWidgetHeader from './ChatWidgetHeader/ChatWidgetHeader';
import ChatWidgetBody from './ChatWidgetBody/ChatWidgetBody';
import ChatWidgetWelcome from './ChatWidgetWelcome/ChatWidgetWelcome';
import { webSocketService } from 'services/websocket.service';
import { chatService } from 'services/chat.service';
import { apiRoutes } from 'services/routes';
import './ChatWidget.scss';

interface ChatWidgetProps {
	closeWidget: () => void;
	setIsHomeScreen: (value: boolean) => void;
	isHomeScreen: boolean;
	hideHeader?: boolean;
}


const clearConversationSession = async () => {
	// Back starts a completely new chat, so remove all session-scoped
	// transactional state instead of only the conversation identifier.
	try {
		await chatService.post(apiRoutes.logout);
		sessionStorage.clear();
		webSocketService.disconnect();
	} catch (e) {
		console.log(e)
		// Optional: handle or log the error if needed
	}
};

const ChatWidget: React.FC<ChatWidgetProps> = ({ closeWidget, isHomeScreen, setIsHomeScreen, hideHeader = false }) => {
	const [chatBodyKey, setChatBodyKey] = useState(0);
	const canReturnToHome = !hideHeader;

	const handleBackToHome = useCallback(() => {
		clearConversationSession();
		setIsHomeScreen(true);
	}, [setIsHomeScreen]);

	const handleIdleSessionReset = useCallback(() => {
		if (canReturnToHome) {
			setIsHomeScreen(true);
			return;
		}

		// Inline / in-app surfaces have no welcome screen — remount for a fresh chat.
		setChatBodyKey(key => key + 1);
	}, [canReturnToHome, setIsHomeScreen]);

	return (
		<div>
			<div className={`chat-window`}>
				{
					isHomeScreen ? <ChatWidgetWelcome
						{
						...{
							closeWidget,
							setIsHomeScreen
						}
						}
					/> :
						<>
							{!hideHeader && <ChatWidgetHeader
								handleBackAction={handleBackToHome}
								closeWidget={closeWidget}
							/>}
							<ChatWidgetBody
								key={chatBodyKey}
								onIdleSessionReset={handleIdleSessionReset}
							/>
						</>
				}
			</div>
		</div>
	);
};

export default ChatWidget;
